import { ProjectDataProductoType } from "./project-data-producto-type.interface";
import { ProjectDataProductoTypeModelo } from "./project-data-producto-type-modelo.interface";
import { ProjectDataProductoTypePanel } from "./project-data-producto-type-panel.interface";

export class ProjectDataProducto {
	public _id: string;

	public idBayoneta: string;
	public idColor: string;

	public tipoBayoneta: string;
	public hexColor: string;

	public panel: ProjectDataProductoTypeModelo;
	public familia: ProjectDataProductoType;
	public modelo: ProjectDataProductoTypePanel;
	public tipoPanel: ProjectDataProductoType;
	public bayoneta: ProjectDataProductoType;

	public altura?: number;

	public anchuraPoste: string;
	public tipoPoste: string;

	public topEdgeCut: number;
}
